import CommonRewardIcon from '../../../assets/images/chests/rewards/common-reward.png';
import EpicRewardIcon from '../../../assets/images/chests/rewards/epic-reward.png';
import RareRewardIcon from '../../../assets/images/chests/rewards/rare-reward.png';
import { TChestRewardVariant } from '../../../types';

export const getChestRewardIcon = (variant: TChestRewardVariant) => {
  switch (variant) {
    case 'common':
      return CommonRewardIcon;
    case 'rare':
      return RareRewardIcon;
    case 'epic':
      return EpicRewardIcon;
    case 'legendary':
      return EpicRewardIcon;
    default:
      return CommonRewardIcon;
  }
};
